import { render, staticRenderFns } from "./drawer-special-brand.vue?vue&type=template&id=5394e6ce&scoped=true&"
import script from "./drawer-special-brand.vue?vue&type=script&lang=js&"
export * from "./drawer-special-brand.vue?vue&type=script&lang=js&"
import style0 from "./drawer-special-brand.vue?vue&type=style&index=0&id=5394e6ce&prod&lang=less&scoped=true&"
import style1 from "./drawer-special-brand.vue?vue&type=style&index=1&id=5394e6ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5394e6ce",
  null
  
)

export default component.exports